import { Env as CoreEnv } from '@core/env.ts'
import { Globals } from '@core/globals.ts'
import { ensureError } from '@core/utils/ensure-error.ts'
import { SubscriberProvider } from '@core/enums/subscriber-provider.ts'

/** @internal */
export class Env extends CoreEnv {
    public static get _isDevMode(): boolean {
        return Globals._env === 'development'
    }

    public static async _getIsWebPushSupported(): Promise<[supported: boolean, reason?: string]> {
        try {
            const [isEnvBaseSupported, envBaseUnsupportedReason] = this._getIsEnvBaseSupported()
            if (!isEnvBaseSupported) {
                return [false, envBaseUnsupportedReason]
            }

            if (this._pushProvider === SubscriberProvider.APNS) {
                return [false, 'APNS subscriptions are not supported']
            }

            if (!this._navigator.cookieEnabled) {
                return [false, 'self.navigator.cookieEnabled is FALSE']
            }

            /**
             * Firefox only throws error here when
             * delete all on exit is enabled
             *
             * ERROR DETAILS
             * Failed to get service worker registration(s): Storage access
             * is restricted in this context due to user settings or private
             * browsing mode. debugger eval code:2:15
             *
             * SecurityError: The operation is insecure.
             */
            try {
                await this._navigator.serviceWorker.getRegistration()
            } catch (err) {
                return [false, 'call to self.navigator.serviceWorker.getRegistration() failed']
            }
        } catch (err) {
            return [false, ensureError(err).message]
        }

        return [true]
    }

    public static get _isSafariPushCapable(): boolean {
        return (
            this._isSafari &&
            typeof this._scope.safari === 'object' &&
            typeof this._scope.safari.pushNotification === 'object'
        )
    }

    public static isAnimationApiSupported() {
        try {
            return !!this._document.getAnimations() && !!this._scope.navigator.userAgentData
        } catch {
            return false
        }
    }
}
